<div class="component-container">
  <section class="component-header">
    <h2>Move History</h2>
  </section>
  <section class="date-range-holder">

    <mat-form-field appearance="fill">
      <mat-label>Data range</mat-label>
      <mat-date-range-input [formGroup]="range" [rangePicker]="picker" class="date-range">
        <input matStartDate formControlName="start" placeholder="Start date" (dateChange)="searchByDateRanges()"/>
        <input matEndDate formControlName="end" placeholder="End date" (dateChange)="searchByDateRanges()"/>
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <section class="date-range-btn-holder">

      <button mat-fab color="accent" (click)="resetTimeRanges()"><mat-icon>restart_alt</mat-icon></button>
     
      <button mat-fab color="primary" (click)="emailMovesReport()" [disabled]="reportMoves.length === 0">
        <mat-icon>mail</mat-icon>
      </button>
    </section>
  </section>

  <ng-container *ngIf="page.totalItems === 0">
    <div class="add-data-display">

      <p>No data</p>
    </div>
  </ng-container>


  <ng-container *ngIf="page.totalItems !== 0">
    <div class="component-view" [ngSwitch]="viewMode">
      <div class="view-moves-list" *ngSwitchCase="'movesList'">

        <section class="moves-list">

          <div class="location-card" *ngFor="let move of page.data">
            <div class="card-header">
              <div class="location-title">
                <h3><strong>Start: </strong>{{ move.start.location }}</h3>

                <mat-icon>arrow_forward</mat-icon>

                <h3><strong>End: </strong>{{ move.end.location }}</h3>
              </div>
            </div>
            <div class="objects-section">
              <section class="icon-holder">
                <mat-icon class="truck-status" [ngStyle]="setTruckStatus(move)">local_shipping</mat-icon>
              </section>

              <section class="trailer-info">
                <h3>Trailer Info</h3>

                <p class="item-info">
                  <strong>Trailer: </strong>{{ move?.end?.trailer?.trailer ?? "no data" }}
                </p>
                <p class="item-info">
                  <strong>Carrier: </strong>{{ move?.end?.trailer?.carrier ?? "no data" }}
                </p>
                <p class="item-info">
                  <strong>Status: </strong>{{ move?.end?.trailer?.status ?? "no data" }}
                </p>
                <p class="item-info">
                  <strong>Created: </strong> {{ move.created | date }}
                </p>
                 <p class="item-info">
                  <strong>Completed: </strong> {{ move.completed | date }}
                </p>
              </section>
              <section class="item-buttons">

                <button mat-fab color="primary" (click)="viewMove(move)" matTooltip="Edit">
                  <mat-icon>edit</mat-icon>
                </button>
              </section>
            </div>
          </div>
        </section>
        <mat-paginator #paginator *ngIf="page?.data?.length !== 0" (page)="handlePageEvent($event)"
          [length]="page.totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
          [pageSizeOptions]="pageSizeOptions" [pageIndex]="page.currentPage" aria-label="Select page">
        </mat-paginator>

      </div>
      <div class="moves-list" *ngSwitchCase="'moveView'">
        <h2>Move Details</h2>

        <div class="location-card">
          <div class="card-header">
            <div class="location-title">
              <h3><strong>Start: </strong> {{ selectedMove.start.location }}</h3>
              <mat-icon>arrow_forward</mat-icon>
              <h3><strong>End: </strong>{{ selectedMove.end.location }}</h3>
            </div>
          </div>
          <div class="objects-section">

            <section class="trailer-info">
              <h2>Trailer Info</h2>

              <p class="item-info">
                <strong>Trailer: </strong>{{ selectedMove?.end?.trailer?.trailer ?? "no data" }}
              </p>
              <p class="item-info">
                <strong>Carrier: </strong>{{ selectedMove?.end?.trailer?.carrier ?? "no data" }}
              </p>
              <p class="item-info">
                <strong>Status: </strong>{{ selectedMove?.end?.trailer?.status ?? "no data" }}
              </p>
            </section>

            <section class="item-buttons">
              <button mat-fab color="warn" (click)="viewMoves()" matTooltip="Back">
                <mat-icon>undo</mat-icon>
              </button>
            </section>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>